import React from "react";
import "./globals.css";
import Footer from "./components/Footer";
import NavigationBar from "./components/NavigationBar";

const Home = () => {
    return(
        <div id="everything">
            <NavigationBar />
            <div className="hero-image-wrapper">
            <img
                src="./images/tremblant.jpg"
                alt="Mont Tremblant in the Fall"
                className="hero-image"
            />
        </div>
        

        {/* Bilingual hero text */}
        <div className="hero-text">
            <div className="hero-content-wrapper">
                <div className="hero-logo">
                    <img src="/images/iwpfi_horizontal_logo.jpg" alt="Logo" />
                </div>
                
                <div className="hero-line-1">
                    12th International Workshop for
                </div>
                <div className="hero-line-1">
                    <span className="highlight">PULMONARY FUNCTIONAL IMAGING</span> – Towards a cure
                </div>
                <div className="hero-line-2">
                    September 23–25, 2026 • Mont-Tremblant, Quebec, Canada
                </div>

                <div className="hero-divider"></div>

                <div className="hero-line-1">
                    12e Atelier International sur 
                </div>
                <div className="hero-line-1">
                    l'<span className="highlight">IMAGERIE FONCTIONNELLE PULMONAIRE</span> – Vers une guérison
                </div>
                <div className="hero-line-2">
                    23–25 septembre 2026 • Mont-Tremblant, Québec, Canada
                </div>
            </div>
            <section className="home-welcome">
                <div className="welcome-details">
                    <summary className="welcome-summary">
                    <span className="welcome-summary-text">WELCOME MESSAGE FROM THE PRESIDENT</span>
                    {/* <span className="welcome-arrow" aria-hidden="true">▾</span> */}
                    </summary>

                    <div className="welcome-body">
                    {/* Salutation */}
                    <p className="welcome-salutation">Dear colleagues, sponsors and supporters:</p>

                    {/* Text + Photo */}
                    <div className="welcome-content">
                        <div className="welcome-text">
                        <p>
                            Along with members of our Scientific Planning Committee (Drs Miranda Kirby, 
                            Sarah Svenningsen, Narinder Paul, Michael Nicholson, David Levin, 
                            Mark Schiebler) and our conference manager (Mme Chantal Goddard), I am 
                            delighted to invite you to the 12th International Workshop for Pulmonary Functional 
                            Imaging in Mont-Tremblant Quebec Canada, from September 23 to 25, 2026.
                        </p>

                        <p>
                            The main theme of this meeting is "Pulmonary Functional Imaging – Towards a Cure”.  
                            We hope this meeting will stimulate clinical translation of pulmonary imaging in 
                            all its forms, towards changing outcomes in patients with lung disease. 
                        </p>

                        <p>
                            A key feature of the International Workshop on Pulmonary Functional Imaging is that 
                            radiologists, respirologists, and basic scientists in AI and medical imaging meet 
                            and exchange ideas with each other. Many of the world's leading clinicians and researchers 
                            in this field from the United States, Europe, Oceania and Asia will attend! 
                        </p>
                        <p>
                            We welcome trainees, residents, fellows, faculty and industry partners to join us in the 
                            discussions and presentations of respiratory imaging excellence!
                        </p>
                        <p>
                            We look forward to seeing you all in Mont-Tremblant, Quebec Canada in September 2026.
                        </p>
                        <p>Bienvenue!</p>
                        <p>Biindigen!</p>
                        <p>Welcome!</p>
                        </div>

                        <div className="welcome-photo-wrapper">
                        <img
                            src="/images/ParragaG_fullres.jpg"
                            alt="Dr. Grace Parraga"
                            className="chair-photo-square"
                        />
                        <p className="signature-name">Grace Parraga PhD, FCAHS, <br />
                        President IWPFI 2026
                        </p>
                        <p className="signature-title">
                        Professor (Medical Biophysics, <br />
                        Biomedical Engineering, Medicine),<br />
                        Tier 1 Canada Research Chair<br />
                        Western University
                        </p>
                        {/* <p className="chair-photo-name">Dr. Grace Parraga</p>
                        <p className="chair-photo-title">Chair, IWPFI 2026</p> */}
                        </div>
                    </div>

                    {/* Signature */}
                    <div className="chair-signature">
                        <img
                        src="/images/ParragaSign.png"
                        alt="Signature of Dr. Grace Parraga"
                        className="signature-img"
                        />
                        {/* <p className="signature-name">Dr. Grace Parraga PhD, FCAHS, President IWPFI 2026</p> */}
                        {/* <p className="signature-title">
                        Professor (Medical Biophysics, Biomedical Engineering, Medicine),<br />
                        Tier 1 Canada Research Chair<br />
                        Western University
                        </p> */}
                    </div>
                    </div>
                </div>
            </section>

            <div className="hero-endorsements">
                <div className="endorsement-text">
                    Endorsed and supported by
                </div>

                <div className="endorsement-logos">
                    <img src="/images/CAR_logo.png" alt="CAR Logo" />
                    <img src="/images/CTS_logo.png" alt="CTS Logo" />
                    <img src="/images/CLA_logo.png" alt="Canadian Lung Association Logo" />
                </div>
            </div>

        </div>

            <Footer />
        </div>
    );
}

export default Home;